import { render, staticRenderFns } from "./EditorDownloadReportModal.vue?vue&type=template&id=06474752&scoped=true"
import script from "./EditorDownloadReportModal.vue?vue&type=script&lang=js"
export * from "./EditorDownloadReportModal.vue?vue&type=script&lang=js"
import style0 from "./EditorDownloadReportModal.vue?vue&type=style&index=0&id=06474752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06474752",
  null
  
)

export default component.exports